import styled from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 6rem);
  margin-left: 6rem;
  height: calc(100vh - 7rem);
  display: flex;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  hr {
    margin-left: 400px;
    width: 1100px;
    border: 1px solid #e9e9e9;
  }

  span {
    margin-bottom: 16px;
    font-size: 14px;
    color: #f30303;
    line-height: 16px;
    font-weight: 700;
    white-space: nowrap;
  }
`;

export const ContentContainer = styled.div`
  margin: 60px 400px 0px;
`;

interface ConsultFormProps {
  hasError: boolean;
}

export const ConsultForm = styled.div<ConsultFormProps>`
  height: 100%;
  left: ${(props) => (props.hasError ? '700px' : '765px')};
  display: flex;
  flex-direction: column;
  margin-top: 3rem;

  p {
    margin: 0px 10px 10px 0px;
    padding-left: 8px;
    color: var(--color-primary);
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
  }
`;

export const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  input {
    margin-top: 8px;
    width: 350px;
    height: 52px;
    border: 1px solid #c4c4c4;
    background: #fff;
    border-radius: 5px;

    padding: 10px;
    font-size: 14px;
  }

  button {
    margin-top: 20px;
    width: 236px;
    height: 40px;
    border-radius: 5px;
    border: 0;
    background: var(--color-primary);

    text-decoration: none;

    color: #fff;
    font-size: 14px;
    line-height: 14px;
    font-weight: 700;

    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
